export default __webpack_public_path__ + "static/media/banner bg.376efafc.png";